import { DocumentCategory, DocumentSubCategory, DocumentUploadCategory, PropertyDocument } from 'types/Documents';

export function getDocumentsByCategory(
    documents: PropertyDocument[] | null
): Record<DocumentSubCategory, PropertyDocument[]> {
    const w9Documents = [];
    const historicalFinancialDocuments = [];
    const monthlyRentRollDocuments = [];
    const mapAndBluePrintDocuments = [];
    const entryExitPhotosDocuments = [];

    for (const document of documents || []) {
        if (document.category?.sub_category === DocumentSubCategory.W9) {
            w9Documents.push(document);
        } else if (document.category?.sub_category === DocumentSubCategory.REVENUE_REPORT) {
            historicalFinancialDocuments.push(document);
        } else if (document.category?.sub_category === DocumentSubCategory.MONTHLY_RENT_ROLL) {
            monthlyRentRollDocuments.push(document);
        } else if (document.category?.sub_category === DocumentSubCategory.PROPERTY_MAP) {
            mapAndBluePrintDocuments.push(document);
        } else if (document.category?.sub_category === DocumentSubCategory.PHOTO) {
            entryExitPhotosDocuments.push(document);
        }
    }

    return {
        [DocumentSubCategory.W9]: w9Documents,
        [DocumentSubCategory.REVENUE_REPORT]: historicalFinancialDocuments,
        [DocumentSubCategory.MONTHLY_RENT_ROLL]: monthlyRentRollDocuments,
        [DocumentSubCategory.PROPERTY_MAP]: mapAndBluePrintDocuments,
        [DocumentSubCategory.PHOTO]: entryExitPhotosDocuments,
    };
}

export type DocumentCategories = {
    w9: DocumentUploadCategory | undefined;
    historicalFinancial: DocumentUploadCategory | undefined;
    monthlyRentRoll: DocumentUploadCategory | undefined;
    mapAndBluePrint: DocumentUploadCategory | undefined;
    entryExitPhotos: DocumentUploadCategory | undefined;
};

export function getDocumentCategories(categories: DocumentUploadCategory[]): DocumentCategories {
    return {
        w9: categories.find(
            (c) => c.category === DocumentCategory.TAX_DOCUMENT && c.sub_category === DocumentSubCategory.W9
        ),
        historicalFinancial: categories.find(
            (c) =>
                c.category === DocumentCategory.HISTORICAL_FINANCIAL &&
                c.sub_category === DocumentSubCategory.REVENUE_REPORT
        ),
        monthlyRentRoll: categories.find(
            (c) =>
                c.category === DocumentCategory.HISTORICAL_FINANCIAL &&
                c.sub_category === DocumentSubCategory.MONTHLY_RENT_ROLL
        ),
        mapAndBluePrint: categories.find(
            (c) =>
                c.category === DocumentCategory.PROPERTY_INFORMATION &&
                c.sub_category === DocumentSubCategory.PROPERTY_MAP
        ),
        entryExitPhotos: categories.find(
            (c) => c.category === DocumentCategory.PROPERTY_INFORMATION && c.sub_category === DocumentSubCategory.PHOTO
        ),
    };
}

export const SUPPORTED_FILE_TYPES = ['.pdf', '.png', '.jpg', '.jpeg', '.xls', '.xlsx', '.csv'].join(',');

export function formatFileSize(bytes: number): string {
    if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)}KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)}MB`;
}
